import React from 'react';
import { DesktopFooter } from './DesktopFooter';
import { MobileFooter } from './MobileFooter';
export const Footer = ({ fields }) => {
    if (!fields) {
        console.warn('Footer component requires fields to be provided');
        return null;
    }
    const { items } = fields;
    return (React.createElement(React.Fragment, null,
        items && React.createElement(DesktopFooter, { items: items }),
        items && React.createElement(MobileFooter, { items: items })));
};
